import React from 'react'
import { Resizable, ResizeCallback } from 're-resizable'
import { Bars2Icon } from '@heroicons/react/24/solid'
import { cn } from '@/utils'

type PixelBasedResizablePanelProps = {
  children: React.ReactNode
  width?: number | string
  minWidth?: number
  maxWidth?: number
  onResize?: ResizeCallback
  onResizeStop?: ResizeCallback
  className?: string
  enable?: {
    right?: boolean
    left?: boolean
  }
  withHandle?: boolean
}

export const PixelBasedResizablePanel = ({
  children,
  width,
  minWidth = 0,
  maxWidth,
  onResize,
  onResizeStop,
  className,
  enable = { right: false, left: false },
  withHandle = false,
}: PixelBasedResizablePanelProps) => {
  return (
    <Resizable
      size={{ width: width || 'auto', height: '100%' }}
      minWidth={minWidth}
      maxWidth={maxWidth}
      enable={enable}
      onResize={onResize}
      onResizeStop={onResizeStop}
      className={cn('flex flex-col', className)}
      style={{ height: '100%', overflow: 'visible' }}
      handleComponent={{
        right: withHandle ? (
          <div className="relative flex h-full w-px items-center justify-center bg-border after:absolute after:inset-y-0 after:left-1/2 after:w-1 after:-translate-x-1/2 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-1">
            <div className="z-10 flex h-4 w-3 items-center justify-center rounded-sm border bg-border cursor-col-resize">
              <Bars2Icon className="h-2.5 w-2.5" />
            </div>
          </div>
        ) : (
          <div className="relative flex h-full w-px items-center justify-center bg-border after:absolute after:inset-y-0 after:left-1/2 after:w-1 after:-translate-x-1/2 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-1 cursor-col-resize" />
        ),
      }}
    >
      <div className="h-full w-full flex flex-col">{children}</div>
    </Resizable>
  )
}

type PixelBasedResizableContainerProps = {
  children: React.ReactNode
  className?: string
}

export const PixelBasedResizableContainer = ({
  children,
  className,
}: PixelBasedResizableContainerProps) => {
  return (
    <div
      className={cn('flex h-full w-full flex-row', className)}
      style={{ height: '100%' }}
    >
      {children}
    </div>
  )
}
